/* eslint-disable sort-keys */

export const ADMIN_PROFILE_MENU = {
  profile: {
    _id: 'profile',
    className: 'profile',
    functionKey: 'handleClickProfile',
    menuTranslationKey: 'profile',
    urlPathname: '/profile',
    viewSelectionKey: 'PROFILE'
  },
  guidedTour: {
    _id: 'guidedTour',
    className: 'guidedTour',
    functionKey: 'handleClickGuidedTour',
    menuTranslationKey: 'guidedTour'
  },
  switchRole: {
    _id: 'switchRole',
    className: 'switchRole',
    functionKey: 'handleClickRoleSwitcher',
    menuTranslationKey: 'switchRole',
    urlPathname: '/switch-role',
    viewSelectionKey: 'ROLE_SWITCHER'
  },
  logout: {
    _id: 'logout',
    className: 'logout',
    functionKey: 'handleLogout',
    menuTranslationKey: 'logout'
  }
};

export const DISTRICT_ADMIN_PROFILE_MENU = ADMIN_PROFILE_MENU;

export const SCHOOL_ADMIN_PROFILE_MENU = ADMIN_PROFILE_MENU;

export const TEACHER_PROFILE_MENU = {
  profile: {
    _id: 'profile',
    className: 'profile',
    functionKey: 'showProfile',
    menuTranslationKey: 'profile',
    urlPathname: '/profile',
    viewSelectionKey: 'PROFILE'
  },
  guidedTour: {
    _id: 'guidedTour',
    className: 'guidedTour',
    functionKey: 'handleClickGuidedTour',
    menuTranslationKey: 'guidedTour'
  },
  archivedClasses: {
    _id: 'archivedClasses',
    className: 'archivedClasses',
    functionKey: 'showArchivedClasses',
    menuTranslationKey: 'archivedClasses',
    urlPathname: '/archived-classes',
    viewSelectionKey: 'ARCHIVED_CLASSES'
  },
  switchRole: {
    _id: 'switchRole',
    className: 'switchRole',
    functionKey: 'handleClickRoleSwitcher',
    menuTranslationKey: 'switchRole',
    urlPathname: '/switch-role',
    viewSelectionKey: 'ROLE_SWITCHER'
  },
  logout: {
    _id: 'logout',
    className: 'logout',
    functionKey: 'handleLogout',
    menuTranslationKey: 'logout'
  }
};

export const STUDENT_PROFILE_MENU = {
  profile: {
    _id: 'profile',
    className: 'profile',
    functionKey: 'showProfile',
    menuTranslationKey: 'profile',
    urlPathname: '/profile',
    viewSelectionKey: 'PROFILE'
  },
  guidedTour: {
    _id: 'guidedTour',
    className: 'guidedTour',
    functionKey: 'handleClickGuidedTour',
    menuTranslationKey: 'guidedTour'
  },
  switchRole: {
    _id: 'switchRole',
    className: 'switchRole',
    functionKey: 'handleClickRoleSwitcher',
    menuTranslationKey: 'switchRole',
    urlPathname: '/switch-role',
    viewSelectionKey: 'ROLE_SWITCHER'
  },
  logout: {
    _id: 'logout',
    className: 'logout',
    functionKey: 'handleLogout',
    menuTranslationKey: 'logout'
  }
};

export const GENERIC_PROFILE_MENU = {
  profile: {
    _id: 'profile',
    className: 'profile',
    functionKey: 'showProfile',
    menuTranslationKey: 'profile',
    urlPathname: '/profile',
    viewSelectionKey: 'PROFILE'
  },
  guidedTour: {
    _id: 'guidedTour',
    className: 'guidedTour',
    functionKey: 'handleClickGuidedTour',
    menuTranslationKey: 'guidedTour'
  },
  switchRole: {
    _id: 'switchRole',
    className: 'switchRole',
    functionKey: 'handleClickRoleSwitcher',
    menuTranslationKey: 'switchRole',
    urlPathname: '/switch-role',
    viewSelectionKey: 'ROLE_SWITCHER'
  },
  logout: {
    _id: 'logout',
    className: 'logout',
    functionKey: 'handleLogout',
    menuTranslationKey: 'logout'
  }
};

export const DEFAULT_ADMIN_PROFILE_MENU_ORDER_ARRAY = [
  'profile', 'switchRole', 'logout'
];

export const DEFAULT_DISTRICT_ADMIN_PROFILE_MENU_ORDER_ARRAY = (
  DEFAULT_ADMIN_PROFILE_MENU_ORDER_ARRAY
);

export const DEFAULT_SCHOOL_ADMIN_PROFILE_MENU_ORDER_ARRAY = (
  DEFAULT_ADMIN_PROFILE_MENU_ORDER_ARRAY
);

export const DEFAULT_TEACHER_PROFILE_MENU_ORDER_ARRAY = [
  'profile', 'archivedClasses', 'switchRole', 'logout'
];

export const DEFAULT_STUDENT_PROFILE_MENU_ORDER_ARRAY = [
  'profile', 'switchRole', 'logout'
];

export const DEFAULT_GENERIC_PROFILE_MENU_ORDER_ARRAY = [
  'profile', 'switchRole', 'logout'
];
